var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('FinanceStats',{ref:"financeStats"}),_c('v-file-input',{ref:"fileinput",attrs:{"label":"Kontoauszug"},on:{"change":_vm.handleFileChange}}),_c('v-btn',{on:{"click":_vm.submitFile}},[_vm._v("Importieren")]),_c('v-list',_vm._l((_vm.result),function(row){return _c('ResultRow',{key:row.count,attrs:{"row":row}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }